import { Radio as AntRadio } from 'antd';

import styled from 'styled-components';

export const Radio = {
    Group: styled(AntRadio.Group)``,
    Button: styled(AntRadio.Button)``,
    Choice: styled(AntRadio)``
};
